import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import JobApplicationForm from '../components/JobApplicationForm';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function JobDetailPage() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check authentication
    const token = localStorage.getItem('candidateToken');
    setIsAuthenticated(!!token);
    
    loadJob();
  }, [jobId]);

  const loadJob = async () => {
    try {
      const response = await fetch(`${API_URL}/api/jobs/${jobId}`);
      if (response.ok) {
        const data = await response.json();
        setJob(data.job || data);
      } else {
        setError('Job not found');
        setTimeout(() => navigate('/jobs'), 2000);
      }
    } catch (error) {
      console.error('Failed to load job:', error);
      setError('Failed to load job details');
    } finally {
      setLoading(false);
    }
  };

  const handleApplyClick = () => {
    if (!isAuthenticated) {
      // Redirect to login with return URL
      localStorage.setItem('returnUrl', `/jobs/${jobId}`);
      navigate('/login');
      return;
    }
    setShowApplicationForm(true);
  };

  const handleApplicationSuccess = (application) => {
    setShowApplicationForm(false);
    alert('✓ Application submitted successfully! Check your dashboard to track its status.');
    // Optionally navigate to dashboard
    // navigate('/dashboard');
  };

  if (loading) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center', color: '#6c757d' }}>
        <div style={{ fontSize: '32px', marginBottom: '10px' }}>⏳</div>
        <p>Loading job details...</p>
      </div>
    );
  }

  if (error || !job) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center', color: '#d33' }}>
        <div style={{ fontSize: '32px', marginBottom: '10px' }}>❌</div>
        <p>{error || 'Job not found'}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Job Header */}
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
        <div style={{ marginBottom: '15px' }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, color: '#1a2f4d', marginBottom: '10px', fontFamily: "'Montserrat', sans-serif" }}>
            {job.title}
          </h1>
          {job.companyName && (
            <p style={{ fontSize: '18px', color: '#6c757d', marginBottom: '15px' }}>{job.companyName}</p>
          )}
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', fontSize: '14px', color: '#6c757d', marginBottom: '20px' }}>
          <span>📍 {job.location}</span>
          <span>💼 {job.type || 'Full-time'}</span>
          {job.salary && <span>💰 {job.salary}</span>}
          <span>📅 Posted {new Date(job.createdAt).toLocaleDateString('en-GB')}</span>
        </div>

        {!showApplicationForm && (
          <button
            onClick={handleApplyClick}
            style={{
              padding: '14px 32px',
              background: '#ff6b35',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            onMouseOver={(e) => e.target.style.background = '#e55a2b'}
            onMouseOut={(e) => e.target.style.background = '#ff6b35'}
          >
            {isAuthenticated ? '✉️ Apply Now' : '🔒 Login to Apply'}
          </button>
        )}
      </div>

      {/* Job Description */}
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#1a2f4d', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif" }}>
          About This Role
        </h2>
        <div style={{ fontSize: '15px', lineHeight: '1.8', color: '#333', whiteSpace: 'pre-wrap' }}>
          {job.description}
        </div>
      </div>

      {/* Requirements */}
      {job.requirements && (
        <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#1a2f4d', marginBottom: '15px', fontFamily: "'Montserrat', sans-serif" }}>
            Requirements
          </h2>
          <div style={{ fontSize: '15px', lineHeight: '1.8', color: '#333', whiteSpace: 'pre-wrap' }}>
            {job.requirements}
          </div>
        </div>
      )}

      {/* Application Form */}
      {showApplicationForm && (
        <JobApplicationForm
          jobId={jobId}
          jobTitle={job.title}
          onSuccess={handleApplicationSuccess}
          onCancel={() => setShowApplicationForm(false)}
        />
      )}
    </div>
  );
}
